module.exports = __webpack_public_path__ + "img/stop-notification.ce7b382a.svg";